module.exports = __webpack_public_path__ + "static/fehintola-6347cedb059db83a8e54194aebed0c5a.png";